<template>
    <button class="header__cart " data-js-drawer-trigger="mini-cart">
        <svg width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M35.4604 0H0V5.91006H2.9886L4.35401 22.6125H31.1065L32.4719 5.91006H35.4604V0Z" fill="black"></path>
        </svg>
    </button>
</template>

<script>
    export default {
        name: "HeaderCart"
    }
</script>

<style scoped>

</style>